<template>
  <list-item
    :booking="booking"
    :link="{ name: 'vetting.show', params: { id: booking.id } }"
  >
    <template v-slot:pill>
      <span v-if="!booking.read" class="label label-default m-r-xs">NEW</span>
      <span v-if="$isNflClient && booking.talent_count === 0" class="label label-info m-r-xs">Player relations to add players</span>
    </template>

    <template v-slot:categories>
       <div v-if="booking.opportunities && booking.opportunities.length" class="flex flex-wrap">
        <span v-for="app in booking.opportunities" :key="app.id" class="label label-info">{{ app.name }}</span>
      </div>
    </template>

    <template v-slot:status>
      <div class="spacer-b-2" v-if="booking.urgent" >
        <span class="label label-danger">Urgent</span>
      </div>
    </template>

    <template v-slot:hero v-if="userCanSeeBudget" >
      <template v-if="$userIsTalent || $userIsManager">
        <template v-if="booking.local_currency">
          {{ booking.local_currency_budget_per_star_as_user_rate | abbreviatedCurrency(booking.local_currency) | nullable }}
        </template>
        <template v-else>
          {{ booking.budget_per_star_as_user_rate | abbreviatedCurrency(booking.currency) | nullable }}
        </template>
      </template>
      <span v-else-if="bookingGrandTotalBudget">{{ bookingGrandTotalBudget | abbreviatedCurrency(booking.local_currency ? booking.local_currency : booking.currency) | nullable }}</span>
      <span v-else>View</span>
    </template>

    <template v-slot:admin>
      <div class="spacer-b-1 flex flex-row" v-if="booking.local_currency">
        <i class="fa fa-info-circle spacer-r-1"></i>
        <span>Estimated conversion to {{booking.local_currency}}. Actual amount may differ due to fluctuating conversion rates.</span>
      </div>
    </template>
  </list-item>
</template>

<script>
import { helpers } from 'mixins/bookings'
import ListItem from '../../list/ListItem'
import MetaItem from '../../list/meta/MetaItem'

export default {
  mixins: [helpers],
  components: {
    ListItem,
    MetaItem
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
